const carouselData = {
	defaultOptions: {
		carouselSelector: '.o-carousel .carousel',
		cellSelector: '.o-carousel__item',
		prevNextButtons: false,
	},
	'carousel--workflow' : {
		extendedOptions: {
			contain: true,
			cellAlign: 'left',
            pageDots: false,
            watchCSS: true,
            // wrapAround: true,
			// customNavigation: {
			// 	previousSelector: '.o-carousel__button--previous',
			// 	nextSelector: '.o-carousel__button--previous',
			// },
		},
    },
    'carousel--zen': {
        extendedOptions: {
            contain: true,
            cellAlign: 'left',
            pageDots: false,
            watchCSS: true,
            // wrapAround: true,
            // customNavigation: {
            //     previousSelector: '.o-carousel__button--previous',
            //     nextSelector: '.o-carousel__button--previous',
            // },
        },
    },
}

export default carouselData



// WEBPACK FOOTER //
// ./js/modules/carousel/carousel.settings.js